import { render, staticRenderFns } from "./OfertaAdicionalIndex.vue?vue&type=template&id=37c3f9ee"
import script from "./OfertaAdicionalIndex.vue?vue&type=script&lang=js"
export * from "./OfertaAdicionalIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports